export default __webpack_public_path__ + "static/media/img_employee_tip0.03cab40f.png";